/// <reference path="../../_ext/Bases/MFGTransDialog.ts" />
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class JobWorkSettlementDialog extends _Ext.MFGTransDialog<JobWorkSettlementRow, any> {
        protected getFormKey() { return JobWorkSettlementForm.formKey; }
        protected getIdProperty() { return JobWorkSettlementRow.idProperty; }
        protected getLocalTextPrefix() { return JobWorkSettlementRow.localTextPrefix; }
        protected getService() { return JobWorkSettlementService.baseUrl; }
        protected getDeletePermission() { return JobWorkSettlementRow.deletePermission; }
        protected getInsertPermission() { return JobWorkSettlementRow.insertPermission; }
        protected getUpdatePermission() { return JobWorkSettlementRow.updatePermission; }
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
        public form = new JobWorkSettlementForm(this.idPrefix);
        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 290;
            q.initMFGItemEditor(this, this.form.Details, Config);

            q.hideEditorLabel(this.form.Details);
            //q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFullWidth(this.form.Details);
            q.setTextRightAlign(this.form.KnockOff);
            q.setTextRightAlign(this.form.Weight);
            q.HideCategoryLable(this.element);
            q.hideEditorLabel(this.form.LedgerName);
            this.form.PartyId.changeSelect2(e => {
                var partyid = parseInt(this.form.PartyId.value);
                if (!isNaN(partyid)) {
                    OMS.VendorService.Retrieve({ EntityId: partyid }, response => {
                        this.form.LedgerName.value = response.Entity.LedgerName;
                    }, { async: false });
                }
            });

            this.form.ProductTypeId.changeSelect2(e => {
                var partyid = parseInt(this.form.PartyId.value);
                var producttypeid = parseInt(this.form.ProductTypeId.value);
                if (isNaN(partyid) || isNaN(producttypeid)) {
                    q.alert('', 'Vendor/Metal Not Selected', true, 2999);
                    return;
                }
                else {
                    Stock.JobTransactionService.GetPartyMetalBalance({ PartyId: partyid, ProductTypeId: producttypeid },
                        response => {
                            if (response.Entity != null) {
                                this.form.Weight.value = response.Entity.PureWeight;
                            }
                        }, { async: false }
                    )
                }

            });
            this.form.KnockOff.changeSelect2(e => {
                var weight = Math.abs((this.form.Weight.value));
                var knockoff = (this.form.KnockOff.value);
                if (knockoff > weight) {
                    q.alert('', 'Knock Off value cannot be Greater than Balance Weight', true, 2999);
                    this.form.KnockOff.value = null;
                    return;
                }

            })
        }

        validateBeforeSave() {
            super.validateBeforeSave();
            var items = this.form.Details.getItems();
            var producttypeid = parseInt(this.form.ProductTypeId.value);
            for (var i = 0; i < items.length; i++)
                items[i].ProductTypeId = producttypeid;
            this.form.Details.setItems(items);
            return true;

        }
    }
}